import React from 'react';

const CopyIcon: React.FC = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='Copy'>
      <path
        id='Combo shape'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.6429 4.5H6V4C6 1.79086 7.79086 0 10 0H16C18.2091 0 20 1.79086 20 4V10C20 12.2091 18.2091 14 16 14H15.5V9.35714C15.5 6.67462 13.3254 4.5 10.6429 4.5ZM10 20H4C1.79086 20 0 18.2091 0 16V10C0 7.79086 1.79086 6 4 6H10C12.2091 6 14 7.79086 14 10V16C14 18.2091 12.2091 20 10 20Z'
        fill='#F9F9FA'
      />
    </g>
  </svg>
);

export default CopyIcon;
